// extracted by mini-css-extract-plugin
module.exports = {"bgImg":"ImgBgResponsive_bgImg__rXRke"};